// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_mx-0";
export var animationContainer = "_mx-1";
export var itemPrice = "_mx-a";
export var itemizedContent = "_mx-9";
export var itemizedHeader = "_mx-7";
export var itemizedRow = "_mx-8";
export var itemizedSection = "_mx-6";
export var modalContent = "_mx-2";
export var orderName = "_mx-3";
export var refundOption = "_mx-4";
export var refundOptionsContainer = "_mx-5";
export var shippingLabel = "_mx-b";
export var totalRow = "_mx-c";